/* Llama Land adult product pages: the adult look's decoration (assets/ll-pdp-adult.css has the rules and the switch notes).
   Runs only when the band section put html.ll-adult on the page (six adult/family Buy Box v2 templates, look A or B).
   Adds, all aria-hidden decoration, existing art only (0 new images):
     - three painted seams (founders, reviews, FAQ) cut from the product's existing adult painting, lit by the direction;
     - quiet ridges at the other section tops; colours read from the rooms around them, so a template reorder still joins up;
     - the phone top strip (the desktop band is hidden under 768) and the painting over the desktop band;
     - the seam llama (one per page, on the founders seam; its own setting, adult_seam_llama);
     - section headings held to 2 lines (Brad's rule; shrinks to an 18px floor on phones, 24px from 768; words never change).
   The paintings follow the flavour: a Cherry / Strawberry tap swaps the product in place and assets/ll-pdp.js re-keys the
   band (data-ll-band); a watcher here repaints the seams, the phone strip and the desktop band art to the new key's set.
   Config: <script id="ll-adult-cfg"> from sections/ll-pdp-band.liquid. */
(function () {
  'use strict';
  var H = document.documentElement;
  if (!H.classList.contains('ll-adult')) return;
  var cfgEl = document.getElementById('ll-adult-cfg');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { return; }
  var base = cfg.base || '';
  var key = cfg.key || '';
  var at = cfg.at || '';
  var img = function (f) { return "url('" + base + f + "')"; }; /* single quotes: it goes inside a style="" attribute */

  /* paintings per band key: three seams + the strip. Adult Multi strawberry has its own field painting; Family D3 (bridge)
     uses the kids midday set; every other product crops its one adult painting three ways. */
  function artFor(k) {
    /* Women and Men Strawberry use their rows-to-the-sun paintings (Brad 10-19, option C); their Cherry pages keep the cherry tree */
    var a = (k === 'womens' || k === 'mens') ? k + '_rows' : k;
    if (k === 'mens_cherry') a = 'adults_multi_cherry'; /* Men Cherry reuses the Adult Multi Cherry painting (Brad 10-19) */
    var v = 'll-pdp-world-' + a + '-v.webp';
    /* adult top band = landscape (band section setting adult_band): no painting over the band; the phone strip shows this
       flavour's 10-08 landscape like the desktop band; the seams keep the adult painting */
    if (cfg.band === 'landscape' && cfg.land && cfg.land[k]) {
      return { seams: [[v, '28% 100%'], [v, '62% 100%'], [v, '86% 100%']], strip: 'll-pdp-band-' + cfg.land[k] + '-m.webp', band: '' };
    }
    if (a === 'adults_multi') {
      var f = 'll-pdp-world-adults_multi-field.webp';
      return { seams: [[f, '28% 100%'], [v, '62% 100%'], [f, '86% 100%']], strip: 'll-pdp-world-adults_multi-field-m.webp', band: f };
    }
    if (at === 'd3') {
      return { seams: [['ll-pdp-world-vitamin_d-a.webp', '50% 100%'], ['ll-pdp-world-vitamin_d-b.webp', '50% 100%'], ['ll-pdp-world-vitamin_d-c.webp', '50% 100%']], strip: 'll-pdp-world-vitamin_d-a.webp', band: '' };
    }
    /* whole-scene strip art (Brad 10-19): the cherry-tree and rows pages put a zoomed-out painting on the band and phone strip */
    var z = /^(womens_cherry|mens_cherry|adults_multi_cherry|womens_rows|mens_rows)$/.test(a) ? 'll-pdp-world-' + a + '-z.webp' : v;
    return { seams: [[v, '28% 100%'], [v, '62% 100%'], [v, '86% 100%']], strip: z, band: z };
  }
  var art = artFor(key);

  var RIDGE = '<svg class="ll-adult-seam__ridge" viewBox="0 0 1440 64" preserveAspectRatio="none" aria-hidden="true" focusable="false">' +
    '<path class="g" d="M0 30 C200 6 420 4 640 20 S1060 50 1260 28 S1400 12 1440 18 V64 H0Z"/>' +
    '<path class="t" d="M0 40 C200 16 420 14 640 30 S1060 60 1260 38 S1400 22 1440 28"/></svg>';
  var QUIET = '<svg viewBox="0 0 1440 52" preserveAspectRatio="none" aria-hidden="true" focusable="false">' +
    '<path class="g" d="M0 26 C260 4 520 6 760 20 S1200 40 1440 14 V52 H0Z"/><path class="t" d="M0 36 C260 14 520 16 760 30 S1200 50 1440 24"/></svg>';

  var mk = function (html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; };
  var visible = function (el) { return !!el && el.getBoundingClientRect().height > 0; };

  /* the room colour of a section: its first non-transparent background, from the host down two levels */
  function bgOf(el) {
    var q = [el], n = 0;
    while (q.length && n < 12) {
      var e = q.shift(); n++;
      var c = getComputedStyle(e).backgroundColor;
      if (c && c !== 'transparent' && !/rgba\(\d+, ?\d+, ?\d+, ?0\)/.test(c)) return c;
      for (var i = 0; i < e.children.length && i < 3; i++) q.push(e.children[i]);
    }
    return '';
  }
  function prevRoom(host) {
    var s = host.closest('.shopify-section') || host;
    var p = s.previousElementSibling;
    while (p && (!visible(p) || p.classList.contains('ll-pdp-band') || /ll_pdp_band/.test(p.id))) p = p.previousElementSibling;
    return (p && bgOf(p)) || 'var(--ad-paper)';
  }
  function dark(c) {
    var m = /rgba?\((\d+), ?(\d+), ?(\d+)/.exec(c || '');
    if (!m) return false;
    return (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) / 255 < 0.45;
  }
  function vars(host) {
    var ground = bgOf(host) || 'var(--ad-paper)';
    return { prev: prevRoom(host), ground: ground, trail: dark(ground) ? 'var(--ad-trail-dark)' : 'var(--ad-trail-light)' };
  }

  function seam(host, n, llama) {
    if (!host || host.querySelector(':scope > .ll-adult-seam')) return;
    var c = vars(host), a = art.seams[n];
    host.classList.add('ll-adult-has-seam');
    host.prepend(mk('<div class="ll-adult-seam" data-ll-seam="' + n + '" aria-hidden="true" style="--seam-img:' + img(a[0]) + ';--seam-pos:' + a[1] +
      ';--seam-prev:' + c.prev + ';--seam-ground:' + c.ground + ';--seam-trail:' + c.trail + '">' +
      '<div class="ll-adult-seam__art"></div><div class="ll-adult-seam__glaze"></div>' +
      RIDGE + (llama ? '<span class="ll-adult-seam-llama"><img src="' + base + 'll-ftr-curly-asleep.webp" alt="" width="480" height="410" loading="lazy" decoding="async"></span>' : '') +
      '</div>'));
  }
  function ridge(host) {
    if (!host || host.querySelector(':scope > .ll-adult-ridge, :scope > .ll-adult-seam')) return;
    var c = vars(host);
    host.classList.add('ll-adult-has-seam');
    host.prepend(mk('<div class="ll-adult-ridge" aria-hidden="true" style="--seam-prev:' + c.prev + ';--seam-ground:' + c.ground + ';--seam-trail:' + c.trail + '">' + QUIET + '</div>'));
  }

  function build() {
    var q = function (s) { return document.querySelector('#main ' + s); };
    /* the reviews seam: on the top reviews module when a page has one; otherwise on the Honor band, the room just above the
       full reviews (the all-reviews section, okendo-frontend, keeps its own band and is never touched) */
    var rev = q('.ll-pdp-rev:not(.ll-ar)');
    if (!visible(rev)) rev = q('.ll-pdp-honor');
    if (!visible(rev)) rev = q('.reviews-widget');
    /* painted seams: founders (carries the seam llama), reviews, FAQ */
    seam(q('.ll-pdp-founders'), 0, true);
    seam(rev, 1, false);
    seam(q('.custom-faq'), 2, false);
    /* quiet ridges everywhere else a room changes */
    ['.difference-table', '.pdp-ingredients-redesign', '.ll-pdp-experts', '.press-mentions', '.ll-pdp-honor', '.reviews-widget'].forEach(function (s) {
      var el = q(s); if (visible(el)) ridge(el);
    });
    /* phone top strip, above the buy box (the band is hidden under 768 on v3 pages) */
    var mp = q('[id*=__main_product_v2]');
    if (mp && !document.querySelector('#main .ll-adult-topstrip')) { /* the band section renders it server-side now */
      mp.prepend(mk('<div class="ll-adult-topstrip" aria-hidden="true"><div class="ll-adult-topstrip__art" style="background-image:' + img(art.strip) + '"></div><i></i><i></i>' +
        '<svg viewBox="0 0 1440 40" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M0 22 C300 4 640 6 900 18 S1300 30 1440 12 V40 H0Z"/></svg></div>'));
    }
    /* desktop band: the painting in the direction's light (Family D3 keeps its midday kids band) */
    var band = document.querySelector('.ll-pdp-band');
    if (band && art.band && !band.querySelector('.ll-adult-band-art')) {
      if (getComputedStyle(band).position === 'static') band.style.position = 'relative';
      band.appendChild(mk('<div class="ll-adult-band-art" aria-hidden="true" style="--ad-band-img:' + img(art.band) + '"><i></i><i></i></div>'));
    }
  }

  /* section headings in 2 lines or fewer at every width (Brad's headline rule); shrink in 0.5px steps, never below 18px */
  function lines(e) {
    var r = document.createRange(); r.selectNodeContents(e);
    var t = {}, n = 0;
    Array.prototype.forEach.call(r.getClientRects(), function (x) { if (x.width > 2) { var k = Math.round(x.top / 6); if (!t[k]) { t[k] = 1; n++; } } });
    return n;
  }
  function fitHeads() {
    var hs = document.querySelectorAll('#main :is(.ll-pdp-h2, .difference-table__heading, .pdp-ingredients-redesign__heading, .custom-faq__heading, .reviews-widget__heading, .ll-c-rv-h)');
    Array.prototype.forEach.call(hs, function (h) {
      h.style.removeProperty('font-size');
      // The scoped mobile preview keeps its approved headline size instead of fitting to two lines.
      if (h.closest('.ll-pdp-founders') && document.querySelector('.pdpv2bb[data-ll-mobile-pilot="adult-multi"]')) return;
      if (!visible(h)) return;
      var floor = window.innerWidth >= 768 ? 24 : 18;
      var px = parseFloat(getComputedStyle(h).fontSize), guard = 0;
      while (lines(h) > 2 && px > floor && guard++ < 60) { px -= 0.5; h.style.setProperty('font-size', px + 'px', 'important'); }
    });
  }

  /* flavour swap: repaint what build() painted, in place (no rebuild, so the seam colours and the llama stay put); the old
     flavour's blurred preview is dropped so it can never show under the new painting (its average colour fills in instead) */
  function repaint(k) {
    if (!k || k === key) return;
    key = k;
    art = artFor(key);
    Array.prototype.forEach.call(document.querySelectorAll('#main .ll-adult-seam[data-ll-seam]'), function (el) {
      var a = art.seams[+el.getAttribute('data-ll-seam')];
      if (!a) return;
      el.style.setProperty('--seam-img', img(a[0]));
      el.style.setProperty('--seam-pos', a[1]);
    });
    var tone = function (f) { return (cfg.tones && cfg.tones[f]) || 'transparent'; };
    var strip = document.querySelector('#main .ll-adult-topstrip__art');
    if (strip) { strip.style.backgroundImage = img(art.strip); strip.style.setProperty('--ad-band-tone', tone(art.strip)); }
    var bandArt = document.querySelector('.ll-pdp-band .ll-adult-band-art');
    if (bandArt && art.band) { bandArt.style.setProperty('--ad-band-img', img(art.band)); bandArt.style.setProperty('--ad-band-tone', tone(art.band)); bandArt.style.setProperty('--ad-band-lqip', 'none'); }
  }
  function watch() {
    var band = document.querySelector('.ll-pdp-band[data-ll-band]');
    if (!band || !window.MutationObserver) return;
    new MutationObserver(function () { try { repaint(band.getAttribute('data-ll-band')); } catch (e) {} })
      .observe(band, { attributes: true, attributeFilter: ['data-ll-band'] });
    try { repaint(band.getAttribute('data-ll-band')); } catch (e) {}
  }

  function run() { try { build(); } catch (e) {} try { watch(); } catch (e) {} try { fitHeads(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHeads);
  var lw = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; fitHeads(); } });
})();
